import { ScLanguageSwitcher } from 'components/LanguageSwitcher/styled';
import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components/macro';

export const ScFooter = styled.div`
  margin-top: 40px;
  padding-bottom: 52px;
  @media (${device.mobile}) {
    padding-bottom: 4px;
  }

  @media print {
    display: none;
  }

  & > div {
    @media (${device.mobile}) {
      padding-top: 12px;
    }
  }

  & .footer-bottom-box {
    display: flex;
    flex-direction: column;

    @media (${device.tablet}) {
      flex-direction: column-reverse;

      & > .footer-bottom {
        display: flex;
        flex-direction: column-reverse;
      }
    }
  }
`;

export const ScNav = styled.div`
  & > ul {
    list-style: none;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;

    & > li {
      margin: 0 8px;

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }

      & > a,
      & > button {
        font-weight: 700;
        font-size: 14px;
        line-height: 1.43;
        text-transform: capitalize;
        color: ${({ theme }) => theme.grayColor1};
        text-decoration: none;
        background: none;
        border: none;
        cursor: pointer;

        @media (hover: hover) {
          &:hover {
            color: ${({ theme }) => theme.whiteColor};
          }
        }
      }

      @media (${device.mobile}) {
        width: 100%;
        margin: 0 0 32px 0;
        text-align: center;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
`;

export const ScCopyright = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: center;
  margin-top: 64px;

  & > .license-link {
    width: 60px;
  }

  & > .copyright {
    flex: 1;
    max-width: 1480px;
    font-size: 12px;
    line-height: 1.67;
    color: ${({ theme }) => theme.secondaryColor};
    text-align: center;
  }

  @media (${device.mobile}) {
    flex-wrap: wrap;
    flex-direction: column;

    & > .copyright {
      width: 100%;
      text-align: center;
    }
  }
`;

export const ScAddons = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  margin-top: 64px;

  & ${ScLanguageSwitcher} {
    display: none;

    @media (${device.tablet}) {
      display: block;
    }
  }

  & .social-network-box {
    display: flex;
    align-items: center;
    gap: 12px;

    & svg {
      width: 48px;
      height: 48px;

      & > rect + path,
      & > rect + g {
        transform-origin: center;
        transition: scale 0.2s ease-in-out;
      }
    }

    @media (hover: hover) {
      & a:hover {
        & svg rect + path,
        & svg rect + g {
          scale: 1.3;
        }
      }
    }

    @media (${device.mobileS}) {
      justify-content: center;
    }
  }
  @media (${device.tablet}) {
    flex-direction: column;
    row-gap: 32px;
  }

  @media (${device.mobileS}) {
    .col {
      width: 100%;
    }
  }
`;

export const ScLicenses = styled.div`
  padding: 16px 10px;
  margin-top: 64px;
  border-top: 1px solid ${({ theme }) => theme.grayColor6};
  border-bottom: 1px solid ${({ theme }) => theme.grayColor6};

  .licenses {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 24px;

    @media (${device.mobile}) {
      justify-content: space-evenly;
      gap: 32px;
    }

    & > div {
      transition: transform 0.2s;
      will-change: transform;

      a {
        display: block;
      }

      img {
        height: 44px;
        max-width: 150px;
        width: auto;
        display: block;
      }

      @media (hover: hover) {
        &:hover {
          transform: scale(1.1);
        }
      }
    }
  }
`;

export const ScAwards = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 24px;
  padding: 16px 10px;
  border-top: 1px solid ${({ theme }) => theme.grayColor6};
  border-bottom: 1px solid ${({ theme }) => theme.grayColor6};
  margin-bottom: 64px;
  & > img {
    max-width: 100%;
  }

  @media (${device.mobile}) {
    gap: 12px;

    & > img {
      max-width: calc(50% - 6px);
    }
  }
`;
